export const discountTypeEnum = {
  MONEY: 0,
  PERCENTAGE: 1,
};
